export default {
  voteWording: {
    id: 'buying_guide_vote',
    defaultMessage: 'Did you find this article useful?',
  },
  yes: {
    id: 'buying_guide_vote_yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'buying_guide_vote_no',
    defaultMessage: 'No',
  },
}
